import React, { useState } from 'react'
import { Empty, InfiniteScroll, NavBar, Toast } from 'antd-mobile';
import { useNavigate } from 'react-router-dom';
import { AddOutline, ClockCircleOutline, EnvironmentOutline, RightOutline, SoundOutline } from 'antd-mobile-icons';
import { getDinnerStatusMeta } from '../dinnerStatus';
import './index.css';
import { useAuth } from '../../app/providers/AuthProvider';
import { dinnerApi } from '../../features/dinner/api/dinnerApi';

export default function DinnerList() {

    const [gameList, setGameList] = useState([]);
    const [loadPage, setLoadPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const navigate = useNavigate();
    const { memberInfo } = useAuth();
    const isAdmin = Number(memberInfo?.admin) === 1;

    const getDinnerListInfo = (page) => {
        Toast.show({
            icon: 'loading',
            duration: 0
        });
        return dinnerApi.getList(page)
            .then(function (response) {
                if (response.data.code === 200) {
                    // 聚餐记录列表不展示已取消聚餐，后端也会过滤，这里做一层兼容兜底。
                    return (response.data.data.records || []).filter(item => Number(item.status) !== 2);
                } else {
                    Toast.show({
                        icon: 'fail',
                    });
                    return [];
                }
            })
            .catch(function (error) {
                console.error('Error fetching user list:', error);
                return [];
            })
            .finally(() => {
                Toast.clear();
            });
    };

    async function loadMore() {
        const append = await getDinnerListInfo(loadPage);
        setGameList(val => [...val, ...append]);
        setHasMore(append?.length > 0);
        const currentPage = loadPage + 1;
        setLoadPage(currentPage);
    }

    return (
        <div className="dinner-container has-unified-nav">
            <NavBar
                className="unified-navbar fixed"
                onBack={() => window.history.back()}
            >
                聚餐记录
            </NavBar>

            {isAdmin && (
                <div className="dinner-admin-create-panel">
                    <div>
                        <span>DINNER ARCHIVE</span>
                        <strong>直接创建聚餐</strong>
                        <p>用于补录或存档，不需要绑定比赛或喜事。</p>
                    </div>
                    <button
                        type="button"
                        className="dinner-admin-create-btn"
                        onClick={() => navigate('/createDinner', { state: { archiveOnly: true } })}
                    >
                        <AddOutline />
                        新建
                    </button>
                </div>
            )}

            {
                gameList?.length > 0 ?
                    <div className="dinner-list">
                        {gameList?.map((dinner, index) => {
                            const dinnerDate = dinner.dinnerDate || dinner.matchTime?.slice?.(0, 10) || dinner.createTime?.slice?.(0, 10) || '日期未记录';
                            const statusMeta = getDinnerStatusMeta(dinner.status);
                            return (
                                <article
                                    key={dinner.id || index}
                                    className="dinner-card"
                                    onClick={() => {
                                        // 无比赛绑定的聚餐进入独立聚餐详情页，有比赛的继续进入比赛详情里的聚餐模块。
                                        if (dinner.gameId) {
                                            navigate(`/games/${dinner.gameId}/history`, { state: { activeTab: 'dinner' } });
                                        } else {
                                            navigate(`/dinners/${dinner.id}`);
                                        }
                                    }}
                                >
                                    <div className="dinner-date-block">
                                        <span>{dinnerDate.slice(5, 7)}</span>
                                        <strong>{dinnerDate.slice(8, 10)}</strong>
                                    </div>
                                    <div className="dinner-content">
                                        <div className="dinner-header">
                                            <div>
                                                <div className="dinner-title">{dinner.position || '暂无地点信息'}</div>
                                                <div className="dinner-subtitle">
                                                    <ClockCircleOutline /> {dinnerDate}
                                                </div>
                                            </div>
                                            <span className={`dinner-status-pill ${statusMeta.className}`}>
                                                {statusMeta.label}
                                            </span>
                                        </div>

                                        {dinner.remark && (
                                            <div className="dinner-remark-box">
                                                <SoundOutline />
                                                <span>{dinner.remark}</span>
                                            </div>
                                        )}

                                        <div className="dinner-footer">
                                            <span><EnvironmentOutline /> {dinner.gameId ? '比赛聚餐' : '独立聚餐'}</span>
                                            <RightOutline />
                                        </div>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                    :
                    <Empty description='暂无聚餐记录' style={{ marginTop: '30vh', '--color': '#86909C' }} />
            }
            <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />
        </div>
    );
}
